import script from "./FloatingAudioPlayer.vue?vue&type=script&setup=true&lang=js"
export * from "./FloatingAudioPlayer.vue?vue&type=script&setup=true&lang=js"

import "./FloatingAudioPlayer.vue?vue&type=style&index=0&id=798e5d07&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-798e5d07"]])

export default __exports__